import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/general/abandon.svg'
import _imports_1 from '@/assets/app/right-arrow.svg'
import _imports_2 from '@/assets/general/warn.svg'
import _imports_3 from '@/assets/general/small-abandon.svg'
import _imports_4 from '@/assets/general/small-access.svg'
import _imports_5 from '../../assets/chat/empty-img-default.svg'
import _imports_6 from '@/assets/general/returnLeft.svg'
import _imports_7 from '@/assets/general/cancleButton.svg'
import _imports_8 from '@/assets/general/link.svg'
import _imports_9 from '@/assets/general/errorMess.svg'
import _imports_10 from '@/assets/general/blue-link.svg'


const _withScopeId = n => (_pushScopeId("data-v-e2bfed18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "websitesLimit" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ruleDetails" }, null, -1))
const _hoisted_5 = { class: "options" }
const _hoisted_6 = { class: "one" }
const _hoisted_7 = { class: "two" }
const _hoisted_8 = { class: "last" }
const _hoisted_9 = {
  key: 0,
  class: "skeletonWrapper"
}
const _hoisted_10 = {
  class: "skeletonMail",
  style: {"margin":"20px 0"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_12 = { class: "content" }
const _hoisted_13 = { class: "top" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "right" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_17 = { class: "content" }
const _hoisted_18 = { class: "top" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "right" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_21 = {
  key: 0,
  class: "record"
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = {
  key: 1,
  class: "mailContent"
}
const _hoisted_24 = { class: "date" }
const _hoisted_25 = { class: "center" }
const _hoisted_26 = {
  key: 0,
  class: "leftUrl forbidStyle"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "",
  class: "link"
}, null, -1))
const _hoisted_28 = {
  key: 1,
  class: "leftUrl"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "",
  class: "link"
}, null, -1))
const _hoisted_30 = { class: "rightTime" }
const _hoisted_31 = { class: "url" }
const _hoisted_32 = ["element-loading-text"]
const _hoisted_33 = {
  key: 0,
  class: "noMore"
}
const _hoisted_34 = {
  key: 2,
  class: "empty"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "empty-img",
  alt: ""
}, null, -1))
const _hoisted_36 = { class: "empty-text" }
const _hoisted_37 = ["infinite-scroll-disabled"]
const _hoisted_38 = { key: 0 }
const _hoisted_39 = {
  key: 1,
  class: "mailContent"
}
const _hoisted_40 = { class: "date" }
const _hoisted_41 = { class: "center" }
const _hoisted_42 = {
  key: 0,
  class: "leftUrl forbidStyle"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "",
  class: "link"
}, null, -1))
const _hoisted_44 = {
  key: 1,
  class: "leftUrl"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "",
  class: "link"
}, null, -1))
const _hoisted_46 = { class: "rightTime" }
const _hoisted_47 = { class: "url" }
const _hoisted_48 = ["element-loading-text"]
const _hoisted_49 = {
  key: 0,
  class: "noMore"
}
const _hoisted_50 = {
  key: 2,
  class: "empty"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "empty-img",
  alt: ""
}, null, -1))
const _hoisted_52 = { class: "empty-text" }
const _hoisted_53 = { class: "addRules" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  class: "returnStyle"
}, null, -1))
const _hoisted_55 = [
  _hoisted_54
]
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ruleDetails" }, null, -1))
const _hoisted_57 = { class: "options" }
const _hoisted_58 = { class: "options" }
const _hoisted_59 = { class: "options" }
const _hoisted_60 = { class: "options" }
const _hoisted_61 = { class: "top" }
const _hoisted_62 = { class: "topContent" }
const _hoisted_63 = { class: "bottomContent" }
const _hoisted_64 = {
  key: 0,
  class: "sendEmail"
}
const _hoisted_65 = { class: "top" }
const _hoisted_66 = { class: "topContent" }
const _hoisted_67 = { class: "bottomContent" }
const _hoisted_68 = { class: "openButton" }
const _hoisted_69 = { class: "addUrl" }
const _hoisted_70 = { class: "title" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bookImg" }, null, -1))
const _hoisted_72 = { class: "bookmarkContent" }
const _hoisted_73 = { class: "header" }
const _hoisted_74 = { class: "bookmarkTitle" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_7 }, null, -1))
const _hoisted_76 = [
  _hoisted_75
]
const _hoisted_77 = ["infinite-scroll-disabled"]
const _hoisted_78 = { key: 0 }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  class: "rightImg"
}, null, -1))
const _hoisted_80 = {
  key: 2,
  class: "bookmarkEmpty"
}
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "empty-img",
  alt: ""
}, null, -1))
const _hoisted_82 = { class: "empty-text" }
const _hoisted_83 = { class: "addToList" }
const _hoisted_84 = { class: "enterUrl" }
const _hoisted_85 = {
  key: 0,
  class: "errorMess"
}
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  class: "errorImg"
}, null, -1))
const _hoisted_87 = { key: 1 }
const _hoisted_88 = ["infinite-scroll-disabled"]
const _hoisted_89 = { class: "ruleUrl" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_10,
  class: "blueLink"
}, null, -1))
const _hoisted_91 = ["onClick"]
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_7 }, null, -1))
const _hoisted_93 = [
  _hoisted_92
]
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "empty-img",
  alt: ""
}, null, -1))
const _hoisted_95 = { class: "empty-text" }
const _hoisted_96 = { class: "oprate" }

import { ref, watch, computed, onMounted, onUnmounted } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { getBrowserLimit, getHistory, addLimit, removeLimit, getBookmark, editNotify } from "@/api/browser/index";
import publicHeader from '@/components/publicHeader/publicHeader.vue'
import { dateFormat, changeOrder } from "@/utils/format";
import { ElMessage } from "element-plus";
import { gaEvent } from "@/utils/format";
import { useRouter } from "vue-router";
import loading from "@/components/chat/loading.vue";
import Tooltip from "@/components/common/tooltip.vue";
import noticeDialog from "@/components/homePage/tabItem/noticeDialog.vue";
import { jsonDataProhibit, jsonDataAccess, jsonDataHistory } from '@/mock/website.js'


export default /*#__PURE__*/_defineComponent({
  __name: 'websitesLimit',
  setup(__props) {

const store = useStore();
let router = useRouter();
const { t } = useI18n();
const deviceId = computed(() => store.state.currentDeviceInfo.id);
const deviceType = computed(() => { return store.state.deviceType })

const isVibe = computed(() => !store.state.isVibe);
const isShowMore750 = computed(() => store.state.isShowMore750);
let noMoreMail = ref(false); // 是否展示没有更多数据文案

const lang = computed(() => store.state.currentLang);

onMounted(async () => {
    if (!isVibe.value) {
        mailList.value = []
        noMoreMail.value = false
        await getFirstUrl()
        await getBrowserHistory()
    } else {
        await getBrowserHistory()
        mailGlobalLoading.value = false
        rightLoading.value = false
        noMoreMail.value = true
        newerAccessLength.value = true
        newerProhibitLength.value = true
        newerAccess.value = jsonDataAccess.data.limiters[0].url as any
        newerProhibit.value = jsonDataProhibit.data.limiters[0].url as any
    }

    gaEvent("WebBlock_PV", {
        event_category: "BrowserMonitor",
        event_label: "None",
    });
})
onUnmounted(() => {
    clearInterval(closeFiveM);
})

const showUpdateTime = ref(false)
let lastUpdateTime = ref(0)

// 五分钟定时更新
let closeFiveM: any
if (!deviceType.value) {
    closeFiveM = setInterval(async () => {
        if (!isVibe.value) {
            mailGlobalLoading.value = true
            rightLoading.value = true
            mailList.value = []
            currentHistoryList.value = []
            originList.value = []
            cumulativeMailList = []
            await getFirstUrl()
            await getBrowserHistory()
        }
    }, 1000 * 60 * 5);
}


watch(deviceId, async () => {
    if (isVibe.value) return
    mailGlobalLoading.value = true
    rightLoading.value = true
    mailList.value = []
    currentHistoryList.value = []
    originList.value = []
    cumulativeMailList = []
    await getFirstUrl()
    await getBrowserHistory()
    if (!isVibe.value || !deviceType) {
        clearInterval(closeFiveM);
        if (!deviceType) setNewInterval()
    }
})

// 浏览器列表
const mailList = ref([]);
// 当前选中历史记录的列表
const currentHistoryList = ref<any>([])
// 左侧骨架屏
let mailGlobalLoading = ref(true);
// 右侧loading
let rightLoading = ref(true);
// 控制页数
const currentPage = ref(1)

const originList = ref([])  // 未经处理的接口数据，用来判断是否加载完所有数据的
let cumulativeMailList: any = [];
const limitType = ref(3)    // 0：正常访问,1：禁止访问,2：访问预警,3：禁止访问+访问预警

const newerProhibit = ref('')
const newerAccess = ref('')

// 需要批量一起加入禁用列表的url集合
const needAddList = ref<any>([])
// 需要批量删除的url列表
const deleteUrlList = ref<any>([])

// 获取访问过的记录
const getBrowserHistory = async (isFromScroll: boolean = false, isFromSync: boolean = false) => {
    if (isVibe.value) {
        rightLoading.value = false
        mailGlobalLoading.value = false
        currentHistoryList.value = changeOrder(jsonDataHistory.data.history_records)
        console.log('currentHistoryList.value', currentHistoryList.value);

        return
    }
    if (!isFromScroll) {
        rightLoading.value = true
        currentPage.value = 1
        noMoreMail.value = false;
    }
    let onePageMailList = [];
    let params = {
        device_id: deviceId.value,
        page: currentPage.value,
        limit_type: limitType.value
    }

    try {
        const res = await getHistory(params)

        if (res.data.code == 200) {
            if (isFromScroll) {
                onePageMailList = res.data.data.history_records
                console.log('originList.value.length', originList.value.length);
                if (originList.value.length == res.data.data.total) {
                    noMoreMail.value = true;
                    return
                } else {
                    cumulativeMailList = onePageMailList
                }
                originList.value = originList.value.concat(cumulativeMailList)
                console.log('originList.value', originList.value);
                currentHistoryList.value = changeOrder(originList.value)
            } else {
                originList.value = res.data.data.history_records
                let history_records = changeOrder(res.data.data.history_records)
                currentHistoryList.value = history_records
            }

            if (!isFromSync) {
                lastUpdateTime.value = res.data.data.update_time
                if (lastUpdateTime.value) {
                    showUpdateTime.value = true
                } else {
                    showUpdateTime.value = false
                }
            } else {
                gaEvent("WebBlock_Sync", {
                    event_category: "BrowserMonitor",
                    event_label: "Success",
                });
                if ((lastUpdateTime.value == res.data.data.update_time)) {
                    ElMessage({
                        message: t("famikeep200['Synchronization successful, no new data']"),
                        type: "success",
                    });
                } else {
                    ElMessage({
                        message: t("chat.syncSuccessed"),
                        type: "success",
                    });
                }

                lastUpdateTime.value = res.data.data.update_time
                if (lastUpdateTime.value) {
                    showUpdateTime.value = true
                } else {
                    showUpdateTime.value = false
                }
            }
        }
    } catch (err) {
        if (isFromSync) {
            gaEvent("WebBlock_Sync", {
                event_category: "BrowserMonitor",
                event_label: "Fail",
            });
            ElMessage({
                message: t("chat.syncFailed"),
                type: "error",
            });
        }
    } finally {
        rightLoading.value = false
        mailGlobalLoading.value = false
        setTimeout(() => {
            store.commit("setSyncLoading", false);
        }, 1000)
    }
}

// 判断规则列表是否显示省略号
const newerAccessLength = ref(false)
const newerProhibitLength = ref(false)
// 获取左侧两个规则列表的最新url展示数据
const getFirstUrl = async () => {
    try {
        let params = {
            device_id: deviceId.value,
            type: 2
        }
        const res = await getBrowserLimit(params)
        console.log('resss', res);
        if (res.data.data.limiters && res.data.data.limiters.length) {
            newerAccess.value = res.data.data.limiters[0].url
        } else {
            newerAccess.value = ''
        }
        if (res.data.data.limiters.length > 1) {
            newerAccessLength.value = true
        } else {
            newerAccessLength.value = false
        }

        let params1 = {
            device_id: deviceId.value,
            type: 1
        }
        const res1 = await getBrowserLimit(params1)
        console.log('resss1', res1);
        if (res1.data.data.limiters && res1.data.data.limiters.length) {
            newerProhibit.value = res1.data.data.limiters[0].url
        } else {
            newerProhibit.value = ''
        }
        if (res1.data.data.limiters.length > 1) {
            newerProhibitLength.value = true
        } else {
            newerProhibitLength.value = false
        }
    } catch (err) {
        console.log('err', err);

    }
}

const ruleList = ref<any>([])
const rulePage = ref(1)

let originSendStatus = ref(false)
// 获取对于的限制类型规则列表
const getTypeLimit = async (isFromScroll: boolean = false) => {
    if (isVibe.value) {
        ruleLoading.value = false
        if (!currentLimitType.value) {
            ruleList.value = jsonDataProhibit.data.limiters
        } else {
            ruleList.value = jsonDataAccess.data.limiters
        }
        return
    }

    let params = {
        device_id: deviceId.value,
        type: !currentLimitType.value ? 1 : 2,
        page: rulePage.value,
    }
    let onePageMailList = [];

    try {
        const res = await getBrowserLimit(params)
        if (res.data.code == 200) {
            if (isFromScroll) {
                onePageMailList = res.data.data.limiters
                if (ruleList.value.length == res.data.data.total) {
                    noMoreRule.value = true;
                    return
                } else {
                    ruleList.value = ruleList.value.concat(onePageMailList)
                }
            } else {
                ruleList.value = res.data.data.limiters
            }
            if (currentLimitType.value) {
                originSendStatus.value = res.data.data.is_send_email
                isSendEmail.value = res.data.data.is_send_email
            }
        }
    } catch (err) {

    } finally {
        ruleLoading.value = false
    }
}

const bookmarkList = ref([])
const bookmarkPage = ref(1)
// 获取书签列表
const getCurrBookmark = async (isFromScroll: boolean = false) => {
    let params = {
        device_id: deviceId.value,
        page: bookmarkPage.value,
    }

    let onePageMailList = [];

    try {
        const res = await getBookmark(params)
        if (res.data.code == 200) {
            if (isFromScroll) {
                onePageMailList = res.data.data.bookmarks
                if (bookmarkList.value.length == res.data.data.total) {
                    noMoreBookmark.value = true;
                    return
                } else {
                    bookmarkList.value = bookmarkList.value.concat(onePageMailList)
                }
            } else {
                bookmarkList.value = res.data.data.bookmarks
            }
        }
    } catch (err) {

    } finally {
        bookmarkLoading.value = false
    }
}

// 选择书签加入禁用列表
const checkBookmark = ref([])
const addToList = () => {
    console.log('checkBookmark', checkBookmark.value);

    showBookmark.value = false
    needAddList.value = needAddList.value.concat(checkBookmark.value)
    ruleList.value = checkBookmark.value.concat(ruleList.value)
    checkBookmark.value = []
}

// 关闭邮件通知
const showCloseDialog = ref(false)
const closeNotify = async (e: any) => {
    // if (isVibe.value) {
    //     isSendEmail.value = !e
    //     ElMessage.error(t("famikeep200['The demo mode does not support this feature, please bind the device first.']"));
    //     return
    // }
    // console.log(e, 'eee');
    // 如果是要关闭通知
    if (e) {
        isSendEmail.value = true
    } else {
        isSendEmail.value = true
        showCloseDialog.value = true
    }
}

const confirmClose = async () => {
    isSendEmail.value = false
    showCloseDialog.value = false
}

// 访问记录的loading
const mailLoading = ref(false);
// 规则列表的loading
const ruleLoading = ref(false);
// 书签列表的loading
const bookmarkLoading = ref(false);

// 访问记录的触底加载
const loadMoreMailList = () => {
    console.log('chudi');
    currentPage.value = currentPage.value + 1
    mailLoading.value = true;
    setTimeout(async () => {
        await getBrowserHistory(true);
        mailLoading.value = false;
    }, 100);
};

// 正在加载数据 或者 已经没有更多数据时 禁止滚动
const disabledMailScroll = computed(
    () => mailLoading.value || noMoreMail.value
);

// 规则列表的触底加载
const loadMoreRuleList = () => {
    console.log('chudi');
    rulePage.value = rulePage.value + 1
    setTimeout(async () => {
        await getTypeLimit(true);
    }, 100);
};
const noMoreRule = ref(false)
const disabledRuleScroll = computed(
    () => noMoreRule.value
);

// 书签列表的触底加载
const loadMoreBookmarkList = () => {
    console.log('chudi');
    bookmarkPage.value = bookmarkPage.value + 1
    setTimeout(async () => {
        await getCurrBookmark(true);
    }, 100);
}
const noMoreBookmark = ref(false)
const disabledBookmarkScroll = computed(
    () => noMoreBookmark.value
);

// 获取日期里面的时间
const getTime = (date: Number) => {
    let time = dateFormat(date, "YYYY-MM-DD HH:mm")
    console.log('time');
    let newArr = time.split(" ")
    return newArr[1]
}

const updateInfo = async () => {
    if (isVibe.value) {
        store.commit("setSyncLoading", false);
        ElMessage.error(t("famikeep200['The demo mode does not support this feature, please bind the device first.']"));
        return
    }
    mailGlobalLoading.value = true
    rightLoading.value = true
    mailList.value = []
    currentHistoryList.value = []
    originList.value = []
    cumulativeMailList = []
    await getFirstUrl()
    await getBrowserHistory(false, true)
    clearInterval(closeFiveM);
    setNewInterval()
}

// 设置新的定时器
const setNewInterval = () => {
    closeFiveM = setInterval(async () => {
        mailGlobalLoading.value = true
        rightLoading.value = true
        mailList.value = []
        currentHistoryList.value = []
        originList.value = []
        cumulativeMailList = []
        await getFirstUrl()
        await getBrowserHistory()
    }, 1000 * 60 * 5);
}

const currentLimitType = ref(0)
const drawer = ref(false)
const isSendEmail = ref(true)
const newUrl = ref('')
const isEmpty = ref(false)
const openLimit = (openType: number) => {
    isEmpty.value = false
    ruleLoading.value = true
    currentLimitType.value = openType
    // getTypeLimit()
    drawer.value = true
    rulePage.value = 1
}

const mountedRuleLength = ref(0)
watch(drawer, async (newV) => {
    if (newV) {
        newUrl.value = ''
        console.log('newV', newV);
        ruleLoading.value = true
        await getTypeLimit()
        mountedRuleLength.value = ruleList.value.length
        // console.log('ruleList.value', ruleList.value, ruleList.value.length);
        // getCurrBookmark()
    } else {
        // showBookmark.value = false
        needAddList.value = []
    }
})

const showDeleteDialog = ref(false)
const deleteId = ref('')
const removeRule = (ruleId: any) => {
    deleteId.value = ruleId
    showDeleteDialog.value = true
}

const closeDialog = () => {
    showDeleteDialog.value = false;
    showCloseDialog.value = false
}

// 删除url
const confirmDelete = async () => {
    ruleList.value.forEach((item: any, index: number) => {
        if (item.id == deleteId.value) {
            ruleList.value.splice(index, 1)
        }
    })
    deleteUrlList.value.push(deleteId.value)
    showDeleteDialog.value = false;
}

// 添加url
const goToAdd = async () => {
    console.log('newUrl', newUrl.value);
    if (newUrl.value.length) {
        needAddList.value.push({ url: newUrl.value })
        ruleList.value.unshift({ url: newUrl.value })
        newUrl.value = ''
    }
}

const deleteUrl = async () => {
    const params = {
        device_id: deviceId.value,
        ids: deleteUrlList.value
    }
    try {
        const res = await removeLimit(params)
    } catch (err) {
    }
}
const addUrl = async () => {
    let urlList: any = []
    needAddList.value.forEach((item: any) => {
        urlList.push(item.url)
    })
    const params = {
        device_id: deviceId.value,
        type: !currentLimitType.value ? 1 : 2,
        urls: urlList
    }
    try {
        const res = await addLimit(params)
    } catch (err) {
    }
}

const changeSendStatus = async () => {
    let params = {
        device_id: deviceId.value,
        is_send_email: isSendEmail.value,
    }
    try {
        const res = await editNotify(params)
    } catch (err) {
    }
}

const saveRule = async () => {
    if (!currentLimitType.value) {
        gaEvent("WebBlock", {
            event_category: "BrowserMonitor",
            event_label: "None",
        });
    } else {
        gaEvent("WebWarning", {
            event_category: "BrowserMonitor",
            event_label: "None",
        });
    }
    if (isVibe.value) {
        ElMessage.error(t("famikeep200['The demo mode does not support this feature, please bind the device first.']"));
        return
    }
    // 如果用户本身就没有一条禁用记录，也没有添加任何记录点击保存不让保存
    if (ruleList.value.length || mountedRuleLength.value) {
        isEmpty.value = false
        if (needAddList.value.length) {
            await addUrl()
        }
        if (deleteUrlList.value.length) {
            await deleteUrl()
        }

        await changeSendStatus()
        // 如果接口初始状态为true，保存时发送状态为false的时候发送该埋点
        if (originSendStatus.value && !isSendEmail.value) {
            gaEvent("AlertMail_ButtonOff", {
                event_category: "BrowserMonitor",
                event_label: "None",
            });
        }
        drawer.value = false

    } else {
        isEmpty.value = true
    }

    await getFirstUrl()
}

const backTo = () => {
    drawer.value = false
}

const showBookmark = ref(false)
const showPop = () => {
    gaEvent("Bookmarks_Button", {
        event_category: "BrowserMonitor",
        event_label: "None",
    });
    bookmarkPage.value = 1
    bookmarkLoading.value = true
    showBookmark.value = true
    getCurrBookmark()
}
const closePop = () => {
    console.log('aaaaaa');
    showBookmark.value = false
    checkBookmark.value = []
}

return (_ctx: any,_cache: any) => {
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(publicHeader, {
        headerName: _ctx.$t('famikeep220.Website Restrictions'),
        showUpdateTime: showUpdateTime.value,
        headerSyncDate: _unref(lastUpdateTime),
        headerSelectData: [],
        onUpdateInfo: updateInfo,
        showRightBox: false
      }, null, 8, ["headerName", "showUpdateTime", "headerSyncDate"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["leftTabs", isShowMore750.value ? '' : 'mobileLeftTabs'])
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('famikeep220.Restriction Rules')), 1),
            _createVNode(_component_el_popover, {
              placement: "bottom-start",
              width: 328,
              trigger: "hover",
              "popper-class": "limitPop"
            }, {
              reference: _withCtx(() => [
                _hoisted_4
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(["popContent", lang.value == 'ar' ? 'reverse' : ''])
                }, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('famikeep220.Restriction Method:')), 1),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('famikeep220.Prohibit Access')), 1),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('famikeep220.Access Alerts')), 1),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("famikeep220['the rule disabling access takes priority.']")), 1)
                ], 2)
              ]),
              _: 1
            })
          ]),
          (_unref(mailGlobalLoading))
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_el_skeleton, {
                  style: {"--el-skeleton-circle-size":"40px","width":"100%","padding-left":"10px"},
                  loading: _unref(mailGlobalLoading),
                  animated: true,
                  count: 2
                }, {
                  template: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_el_skeleton_item, {
                        variant: "circle",
                        style: {"margin-right":"12px"}
                      }),
                      _createVNode(_component_el_skeleton_item, {
                        variant: "text",
                        style: {"width":"55%"}
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["mailList", isShowMore750.value ? '' : 'mobileMailList'])
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["abandon pointer", isShowMore750.value ? '' : 'mobileAbandon']),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (openLimit(0)))
                }, [
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('famikeep220.Prohibited Access')), 1),
                    _createElementVNode("div", {
                      class: _normalizeClass(isShowMore750.value ? 'bottom' : 'mobileBottom')
                    }, [
                      _createTextVNode(_toDisplayString(newerProhibit.value ? newerProhibit.value : _ctx.$t('famikeep220.Click to Add Restricted Website')) + " ", 1),
                      (newerProhibitLength.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, "..."))
                        : _createCommentVNode("", true)
                    ], 2)
                  ]),
                  _hoisted_15
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["abandon pointer", isShowMore750.value ? '' : 'mobileAbandon']),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (openLimit(1)))
                }, [
                  _hoisted_16,
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('famikeep220.Access Warning')), 1),
                    _createElementVNode("div", {
                      class: _normalizeClass(isShowMore750.value ? 'bottom' : 'mobileBottom')
                    }, [
                      _createTextVNode(_toDisplayString(newerAccess.value ? newerAccess.value : _ctx.$t('famikeep220.Click to Add Restricted Website')) + " ", 1),
                      (newerAccessLength.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_19, "..."))
                        : _createCommentVNode("", true)
                    ], 2)
                  ]),
                  _hoisted_20
                ], 2),
                (!isShowMore750.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      (_unref(rightLoading))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            _createVNode(loading, { class: "locationLoading" })
                          ]))
                        : (!_unref(rightLoading) && currentHistoryList.value.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentHistoryList.value, (item, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "historyList",
                                  key: index
                                }, [
                                  _createElementVNode("div", _hoisted_24, _toDisplayString(Object.keys(item)[0]), 1),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item[Object.keys(item)[0]], (cItem, cIndex) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "body",
                                      key: cIndex
                                    }, [
                                      _createElementVNode("div", _hoisted_25, [
                                        (cItem.limit_type == 1)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                              _hoisted_27,
                                              _createTextVNode(" " + _toDisplayString(_ctx.$t('famikeep220.Prohibited Access')), 1)
                                            ]))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                              _hoisted_29,
                                              _createTextVNode(" " + _toDisplayString(_ctx.$t('famikeep220.Access Warning')), 1)
                                            ])),
                                        _createElementVNode("div", _hoisted_30, _toDisplayString(cItem.date ? getTime(cItem.date) : ""), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_31, _toDisplayString(cItem.url), 1)
                                    ]))
                                  }), 128))
                                ]))
                              }), 128)),
                              _withDirectives(_createElementVNode("div", {
                                "element-loading-text": _ctx.$t('chat.loadingText'),
                                style: _normalizeStyle({ 'margin-top': mailLoading.value ? '40px' : '10px' })
                              }, null, 12, _hoisted_32), [
                                [_directive_loading, mailLoading.value]
                              ]),
                              (_unref(noMoreMail))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_ctx.$t("chat.noMoreText")), 1))
                                : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_34, [
                              _hoisted_35,
                              _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.$t("chat.noInfoText")), 1)
                            ]))
                    ]))
                  : _createCommentVNode("", true)
              ], 2))
        ], 2),
        (isShowMore750.value)
          ? _withDirectives((_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "rightTabs",
              "infinite-scroll-immediate": false,
              "infinite-scroll-disabled": disabledMailScroll.value,
              style: {"overflow":"auto"},
              "infinite-scroll-distance": "1"
            }, [
              (_unref(rightLoading))
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    _createVNode(loading, { class: "locationLoading" })
                  ]))
                : (!_unref(rightLoading) && currentHistoryList.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentHistoryList.value, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "historyList",
                          key: index
                        }, [
                          _createElementVNode("div", _hoisted_40, _toDisplayString(Object.keys(item)[0]), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item[Object.keys(item)[0]], (cItem, cIndex) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "body",
                              key: cIndex
                            }, [
                              _createElementVNode("div", _hoisted_41, [
                                (cItem.limit_type == 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                      _hoisted_43,
                                      _createTextVNode(" " + _toDisplayString(_ctx.$t('famikeep220.Prohibited Access')), 1)
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                      _hoisted_45,
                                      _createTextVNode(" " + _toDisplayString(_ctx.$t('famikeep220.Access Warning')), 1)
                                    ])),
                                _createElementVNode("div", _hoisted_46, _toDisplayString(cItem.date ? getTime(cItem.date) : ""), 1)
                              ]),
                              _createElementVNode("div", _hoisted_47, _toDisplayString(cItem.url), 1)
                            ]))
                          }), 128))
                        ]))
                      }), 128)),
                      _withDirectives(_createElementVNode("div", {
                        "element-loading-text": _ctx.$t('chat.loadingText'),
                        style: _normalizeStyle({ 'margin-top': mailLoading.value ? '40px' : '10px' })
                      }, null, 12, _hoisted_48), [
                        [_directive_loading, mailLoading.value]
                      ]),
                      (_unref(noMoreMail))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString(_ctx.$t("chat.noMoreText")), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_50, [
                      _hoisted_51,
                      _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.$t("chat.noInfoText")), 1)
                    ]))
            ], 8, _hoisted_37)), [
              [_directive_infinite_scroll, loadMoreMailList]
            ])
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_el_drawer, {
        "custom-class": isShowMore750.value ? '' : 'myDrawer',
        modelValue: drawer.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((drawer).value = $event)),
        "with-header": false,
        size: isShowMore750.value ? '30%' : '100%'
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_53, [
            true
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "returnLeft",
                  onClick: backTo
                }, _hoisted_55))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["setRule", isShowMore750.value ? '' : 'mobileSetRule'])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["title", lang.value == 'ar' ? 'reverse' : ''])
              }, [
                _createElementVNode("div", null, _toDisplayString(_ctx.$t('famikeep220.Set Restriction Rules')), 1),
                _createVNode(_component_el_popover, {
                  placement: "bottom-start",
                  width: 328,
                  trigger: "hover",
                  "popper-class": "rulePop"
                }, {
                  reference: _withCtx(() => [
                    _hoisted_56
                  ]),
                  default: _withCtx(() => [
                    (!currentLimitType.value)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(["content", lang.value == 'ar' ? 'reverse' : ''])
                        }, [
                          _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.$t('famikeep220.For example')), 1),
                          _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.$t("famikeep220['If you enter the specific website page']")), 1)
                        ], 2))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: _normalizeClass(["content", lang.value == 'ar' ? 'reverse' : ''])
                        }, [
                          _createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.$t('famikeep220.enter example')), 1),
                          _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.$t("famikeep220['enter the specific webpage']")), 1)
                        ], 2))
                  ]),
                  _: 1
                })
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["firstCheck", lang.value == 'ar' ? 'reverse' : ''])
              }, [
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("span", _hoisted_62, _toDisplayString(currentLimitType.value ? _ctx.$t('famikeep220.Access Warning') :
                                _ctx.$t('famikeep220.Prohibited Access')), 1),
                  _createElementVNode("span", _hoisted_63, _toDisplayString(currentLimitType.value ? _ctx.$t("famikeep220['This option will allow']") :
                                    _ctx.$t("famikeep220['This option will block']")), 1)
                ]),
                (currentLimitType.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                      _createElementVNode("div", _hoisted_65, [
                        _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.$t('famikeep220.Send records by email')), 1),
                        _createElementVNode("span", _hoisted_67, _toDisplayString(_ctx.$t('famikeep220.When enabled')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_68, [
                        _createVNode(_component_el_switch, {
                          modelValue: isSendEmail.value,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isSendEmail).value = $event)),
                          class: "ml-2",
                          size: "large",
                          onChange: closeNotify,
                          style: {"--el-switch-on-color":"#2db249","--el-switch-off-color":"#c3c6ca"}
                        }, null, 8, ["modelValue"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 2)
            ], 2),
            _createElementVNode("div", _hoisted_69, [
              _createElementVNode("div", _hoisted_70, _toDisplayString(_ctx.$t('famikeep220.Enter the website to be restricted')), 1),
              _createElementVNode("div", {
                class: "bookmark",
                onClick: showPop
              }, [
                _hoisted_71,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("famikeep220.Bookmark")), 1)
              ]),
              (showBookmark.value)
                ? _withDirectives((_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["bookmarkPop", isShowMore750.value ? '' : 'mobileBookmarkPop'])
                  }, [
                    _createElementVNode("div", _hoisted_72, [
                      _createElementVNode("div", _hoisted_73, [
                        _createElementVNode("div", _hoisted_74, _toDisplayString(_ctx.$t("famikeep220.Bookmark list")), 1),
                        _createElementVNode("div", {
                          class: "closePop",
                          onClick: closePop
                        }, _hoisted_76)
                      ]),
                      _withDirectives((_openBlock(), _createElementBlock("div", {
                        class: "options",
                        "infinite-scroll-immediate": false,
                        "infinite-scroll-disabled": disabledBookmarkScroll.value,
                        style: {"overflow":"auto"},
                        "infinite-scroll-distance": "1"
                      }, [
                        (bookmarkLoading.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                              _createVNode(loading, {
                                class: "locationLoading",
                                style: {"background":"#fff"}
                              })
                            ]))
                          : (!bookmarkLoading.value && bookmarkList.value.length)
                            ? (_openBlock(), _createBlock(_component_el_checkbox_group, {
                                key: 1,
                                modelValue: checkBookmark.value,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((checkBookmark).value = $event)),
                                class: "bookmarkWrap"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bookmarkList.value, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_checkbox, {
                                      class: "singleItem",
                                      label: item,
                                      key: index
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", {
                                          class: _normalizeClass(["rightUrl", isShowMore750.value ? '' : 'mobileRightUrl'])
                                        }, [
                                          _hoisted_79,
                                          _createVNode(Tooltip, {
                                            content: item.url
                                          }, null, 8, ["content"])
                                        ], 2)
                                      ]),
                                      _: 2
                                    }, 1032, ["label"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_80, [
                                _hoisted_81,
                                _createElementVNode("div", _hoisted_82, _toDisplayString(_ctx.$t("chat.noMoreText")), 1)
                              ]))
                      ], 8, _hoisted_77)), [
                        [_directive_infinite_scroll, loadMoreBookmarkList]
                      ]),
                      _createElementVNode("div", _hoisted_83, [
                        _createElementVNode("div", {
                          class: "addButton",
                          onClick: addToList
                        }, _toDisplayString(_ctx.$t('famikeep220.Add')), 1)
                      ])
                    ])
                  ], 2)), [
                    [_directive_click_outside, closePop]
                  ])
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_84, [
              _createVNode(_component_el_input, {
                modelValue: newUrl.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((newUrl).value = $event)),
                class: _normalizeClass(["setlist", [isEmpty.value ? 'emptyStyle' : '', lang.value == 'ar' ? 'inputReverse' : '', isShowMore750.value ? '' : 'mobileSetlist']]),
                placeholder: _unref(t)(`famikeep220['Enter the URL']`)
              }, null, 8, ["modelValue", "class", "placeholder"]),
              _createElementVNode("div", {
                class: "addUrlButton right-style",
                onClick: goToAdd
              }),
              (isEmpty.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                    _hoisted_86,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("famikeep220['Enter the website to be restricted']")), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            (ruleLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                  _createVNode(loading, {
                    class: _normalizeClass(["ruleLoading", currentLimitType.value ? 'shortHeight' : ''])
                  }, null, 8, ["class"])
                ]))
              : (!ruleLoading.value && ruleList.value.length)
                ? _withDirectives((_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: _normalizeClass(["ruleList", [currentLimitType.value ? 'shortHeight' : '', isShowMore750.value ? '' : 'addMargin']]),
                    "infinite-scroll-immediate": false,
                    "infinite-scroll-disabled": disabledRuleScroll.value,
                    style: {"overflow":"auto"},
                    "infinite-scroll-distance": "1"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ruleList.value, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "ruleItem",
                        key: item.id
                      }, [
                        _createElementVNode("div", _hoisted_89, [
                          _hoisted_90,
                          _createTextVNode(" " + _toDisplayString(item.url), 1)
                        ]),
                        _createElementVNode("div", {
                          class: "cancleButton",
                          onClick: ($event: any) => (removeRule(item.id))
                        }, _hoisted_93, 8, _hoisted_91)
                      ]))
                    }), 128))
                  ], 10, _hoisted_88)), [
                    [_directive_infinite_scroll, loadMoreRuleList]
                  ])
                : (_openBlock(), _createElementBlock("div", {
                    key: 3,
                    class: _normalizeClass(["ruleEmpty", currentLimitType.value ? 'shortHeight' : ''])
                  }, [
                    _hoisted_94,
                    _createElementVNode("div", _hoisted_95, _toDisplayString(_ctx.$t("famikeep220['Please add the restricted URL']")), 1)
                  ], 2)),
            _createElementVNode("div", _hoisted_96, [
              _createElementVNode("div", {
                class: "save opateBtn",
                onClick: saveRule
              }, _toDisplayString(_ctx.$t('famikeep200.Save')), 1),
              _createElementVNode("div", {
                class: "back opateBtn",
                onClick: backTo
              }, _toDisplayString(_ctx.$t('famikeep200.Back')), 1)
            ])
          ])
        ]),
        _: 1
      }, 8, ["custom-class", "modelValue", "size"])
    ]),
    (showDeleteDialog.value)
      ? (_openBlock(), _createBlock(noticeDialog, {
          key: 0,
          visible: showDeleteDialog.value,
          width: 480,
          showHeader: false,
          info: _unref(t)(`famikeep220['Are you sure']`),
          onConfirm: closeDialog,
          onCancle: confirmDelete,
          Cancel: _ctx.$t('pop.yes'),
          Okay: _ctx.$t('pop.no')
        }, null, 8, ["visible", "info", "Cancel", "Okay"]))
      : _createCommentVNode("", true),
    (showCloseDialog.value)
      ? (_openBlock(), _createBlock(noticeDialog, {
          key: 1,
          visible: showCloseDialog.value,
          width: 480,
          showHeader: false,
          info: _unref(t)(`famikeep220['Sure close']`),
          onConfirm: closeDialog,
          onCancle: confirmClose,
          Cancel: _ctx.$t('pop.yes'),
          Okay: _ctx.$t('pop.no')
        }, null, 8, ["visible", "info", "Cancel", "Okay"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})